"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var campaignChangeHandlers = [];
var campaignChangeSubscribers = [];
exports.setHandler = function (id, callback) {
  if (!campaignChangeHandlers[id]) {
    campaignChangeHandlers[id] = [];
  }
  notifyCampaignSubscribers(id, undefined);
  campaignChangeHandlers[id].push({
    id: id,
    callback: callback
  });
};
exports.subscribeToCampaigns = function (callback) {
  campaignChangeSubscribers.push(callback);
};
exports.sendInitialValue = function (id, value, callback) {
  sendValue(value, callback);
  notifyCampaignSubscribers(id, value);
};
exports.updateCampaign = function (id, value) {
  var callbacks = getCallbacks(id);
  callbacks.forEach(function (_a) {
    var callback = _a.callback;
    callback(value);
  });
  notifyCampaignSubscribers(id, value);
};
var notifyCampaignSubscribers = function notifyCampaignSubscribers(id, value) {
  campaignChangeSubscribers.forEach(function (cb) {
    cb(id, value);
  });
};
var getCallbacks = function getCallbacks(id) {
  return campaignChangeHandlers[id];
};
var sendValue = function sendValue(value, callback) {
  callback(value);
};
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/campaign/index.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/campaign/index.js");
  }
}();